import React, { Component, Fragment } from 'react'
import styles from './productChoose.scss'
import { Button, Space, message } from 'antd'
import User from '../../modules/user'
import { SYSCON } from '@/const/const'
import Consult from '@/components/consult'
import UserForm from '@/components/userForm'
import AppointmentForm from '@/components/appointment-form'
class ProductItem extends Component {
  constructor(props) {
    super(props)
    this.userRef = React.createRef()
    this.conRef = React.createRef()
    this.appointmentRef = React.createRef()
    this.productId = ''
    this.btnType = ''
    this.allOrgHasBuy = '' // 该用户“作为内部用户的任一根机构”已试用或激活过对应“产品”
    console.log('this.props', this.props)
  }
  getNaviUrl = () => {
    const prodCd = SYSCON.PlatAppSmarterFin
    return `${process.env.REACT_APP_PRODUCT_URL}&token=${localStorage.getItem(SYSCON.Token)}&appCatCd=${SYSCON.PlatAppWorkbench}&prodId=${this.productId}&prodCd=${prodCd}${this.allOrgHasBuy ? '&allOrgHasBuy=' + this.allOrgHasBuy : ''}`
  }
  handleConsult = ()=>{
    this.conRef.current.open()
  }
   wdStyles = {
     width: '80px',
     display: 'flex',
     justifyContent: 'center'
   }
   handleProduct = async(btnType) => {
     this.btnType = btnType
     const user = new User()
     /**
      * 1. 判断是否登录， 未登录的话，要先登录
      * 2. 判断用户是否有购买资格(普及版特殊，多一个字段smarterFinTradeEditionFlag)
      * 2.1 如果是购买操作 该用户“作为内部用户的任一根机构”已正式激活某个产品的情况下，依旧可以正常产品购买流程中进行该产品的购买，但必须创建另外一个根机构
      * 2.2 如果是试用操作 若该用户“作为内部用户的任一根机构”已试用或激活过对应“产品”则提示其不能重复试用
      * 3. 获取产品id
      * 4. 如果是普及版、组织过滤为个人组织， 如果是其他版本 组织过滤为企业组织
      * 5. 如果filter结果为0 直接跳转到产品层级选择界面
      * 6. 如果filter结果为1 带上组织信息 跳转产品层级选择界面
      * 7. 如果filter结果大于1 先选择组织 再跳转
      */
     if (!user.getLoginStatu()) {
       this.userRef.current.open()
       return
     }
     this.productId = await user.getProductId()
     const userInfo = user.getUserInfo()
     const prodCd = SYSCON.PlatAppSmarterFin
     const smarterFinTradeEditionFlag = this.props.title === '普及版'
     user.checkPurchaseQualification(userInfo.id, prodCd, smarterFinTradeEditionFlag)
       .then(checkRes => {
         // checkRes 是否通过检查
         if (this.btnType === 'try') {
           if (!checkRes) {
             this.showTip('试用')
             return
           }
         }
         if (this.btnType === 'buy') {
           if (smarterFinTradeEditionFlag && !checkRes) {
             this.showTip('购买')
             return
           }
           this.allOrgHasBuy = checkRes ? '0' : '1'
         }
         window.location.href = (this.getNaviUrl())
       })
       .catch(err => {
         console.log('err', err)
       })
   }
   showTip = (actionNm) => {
     const content = `您已试用或激活该产品，无法重复${actionNm}!`
     message.warning(content)
   }
   handleAppointment(title) {
     this.appointmentRef.current.open(title, '9050.150')
   }
   render() {
     return (
       <Fragment>
         <UserForm onRef={this.userRef} />
         <Consult onRef={this.conRef} />
         <AppointmentForm onRef={this.appointmentRef}/>
         <div className={`${styles['selected']} ${styles['pricing-box']}`}>
           {/* <img src={this.props.img} alt='product img' /> */}
           <h4 className={styles['title-text']}>{this.props.title}</h4>
           <p className={styles['price-text']}>{this.props.price}</p>
           <div className= {styles['pricing-list']}>{this.props.contents}</div>
           {/* { this.props.freeStr && !((+this.props.freeTrialPerd || 0) === 0) ? <span className={styles['sug-info']}>{'免费试用' + +this.props.freeTrialPerd + '个月'}</span> : ''} */}
           <div className={styles['btn-items']}>
             <Space >

               {((+this.props.freeTrialPerd || 0) === 0) ? <Button style={this.wdStyles} type='primary' onClick={()=>this.handleAppointment(this.props.title)}>
                 预约试用
               </Button> : this.props.tryStr ? <Button type='primary' style={this.wdStyles} onClick={()=>this.handleProduct(this.props.tryType)}>
                 {this.props.tryStr}
               </Button> : ''}

               {this.props.buyStr ? <Button type='primary' style={this.wdStyles} onClick={()=>this.handleProduct(this.props.buyType)}>
                 {this.props.buyStr}
               </Button> : ''}
               {this.props.consultStr ? <Button type='primary' style={this.wdStyles} onClick={()=>this.handleConsult()}>
                 {this.props.consultStr}
               </Button> : ''}
             </Space>
           </div>
         </div>
       </Fragment>

     )
   }
}

export default ProductItem
